'use client';
import styled from 'styled-components';
import { colors, breakPoints } from '@/styles';

export const RepositorySidebar = styled.div<{}>`
  display: flex;
  flex-direction: column;
  gap: 20px;

  .separator {
    width: 100%;
    height: 1px;
    background-color: ${colors.secondary.lightGray3};
  }

  p {
    overflow-wrap: break-word;
  }
`;

export const Activity = styled.div<{}>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-size: 14px;
  color: ${colors.primary.subtleText};
  svg {
    width: 14px;
    height: 14px;
  }
  & > * {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 10px;
  }
`;
